import type { ThemeConfig } from 'antd';

export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#1890ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#f5222d',
    colorInfo: '#1890ff',
    
    borderRadius: 6,
    fontSize: 14,
    
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',
    colorBgLayout: '#f0f2f5',
    
    colorText: 'rgba(0, 0, 0, 0.88)',
    colorTextSecondary: 'rgba(0, 0, 0, 0.65)',
    colorTextTertiary: 'rgba(0, 0, 0, 0.45)',
    
    colorBorder: '#d9d9d9',
    colorBorderSecondary: '#f0f0f0',
  },
  
  components: {
    Button: {
      controlHeight: 40,
      controlHeightSM: 32,
      controlHeightLG: 48,
      borderRadius: 6,
      fontWeight: 500,
    },
    
    Input: {
      controlHeight: 40,
      controlHeightSM: 32,
      controlHeightLG: 48,
      borderRadius: 6,
      paddingInline: 12,
    },
    
    Select: {
      controlHeight: 40,
      controlHeightSM: 32,
      controlHeightLG: 48,
      borderRadius: 6,
    },
    
    Table: {
      headerBg: '#fafafa',
      headerColor: 'rgba(0, 0, 0, 0.88)',
      borderRadiusLG: 8,
      cellPaddingBlock: 12,
      cellPaddingInline: 16,
    },
    
    Card: {
      borderRadiusLG: 12,
      paddingLG: 24,
    },
    
    Modal: {
      borderRadiusLG: 12,
      paddingLG: 24,
    },
    
    Menu: {
      itemBorderRadius: 6,
      itemMarginBlock: 4,
      itemMarginInline: 8,
      itemPaddingInline: 12,
    },
    
    Layout: {
      headerBg: '#ffffff',
      siderBg: '#001529',
      triggerBg: '#002140',
    },
  },
};
